(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/parsers/parse-date-picker.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/parsers/parse-date-picker.js');

'use strict';

function createDate(date) {
  if (!date) {
    return new Date();
  }
  if (date instanceof Date) {
    return date;
  }
  let utcDate;
  if (typeof date === 'string') {
    let time;
    let year = 0;
    let month = 0;
    let day = 0;
    let hours = 0;
    let minutes = 0;

    const [dateString, timeString] = date.split('T');
    [year, month, day] = dateString.split('-');
    if (timeString) {
      [time] = timeString.split('+');
      [hours, minutes] = time.split(':');
    }
    utcDate = new Date(Date.UTC(year, month - 1, day, hours, minutes));
  }
  if (typeof date === 'object' && date.pick) {
    date = date.pick;
  }
  if (typeof date === 'number') {
    utcDate = new Date(date);
    const dateString = utcDate.toString();
    let [, timeZone] = dateString.split('+');
    let timeZoneSign = 1;
    if (!timeZone) {
      [, timeZone] = dateString.split('-');
      timeZoneSign = -1;
    }

    const timeZoneOffset = parseInt(timeZone, 10) * timeZoneSign / 100;
    if (!isNaN(timeZoneOffset)) {
      utcDate.setHours(utcDate.getHours() + timeZoneOffset);
    }
  }
  return new Date(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate());
}
function parseDatesByMonth(_ref) {
  let {
    resultDates,
    month,
    year
  } = _ref;
  if (Array.isArray(resultDates)) {
    const dates = [];
    resultDates.forEach(_ref2 => {
      let {
        date: dateString,
        drawNumber,
        product
      } = _ref2;
      const date = createDate(dateString);
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();
      if (m === month && y === year) {
        dates.push({
          date: d,
          drawNumber,
          productDrawId: svs.numbergames.productMapping.getProductDrawId(product)
        });
      }
    });
    return dates;
  }
}
function addDates(datesArray) {
  if (Array.isArray(datesArray)) {
    const dates = {};
    datesArray.forEach(date => {
      dates[date.date] = date;
    });
    return dates;
  }
}
function addAddonDates(addonDates) {
  let datesMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (Array.isArray(addonDates)) {
    addonDates.forEach(_ref3 => {
      let {
        date,
        drawNumber,
        productDrawId
      } = _ref3;
      const drawDate = datesMap[date];
      drawDate.addonDrawId = productDrawId;
      drawDate.addonDrawNumber = drawNumber;
    });
    return datesMap;
  }
}
function checkAddonDates(dates, addonDates, product) {
  if (dates && Array.isArray(addonDates)) {
    if (svs.numbergames.productMapping.isVikinglotto(product)) {
      const drawId = svs.numbergames.productMapping.getProductDrawId('ONSJOKER');
      addonDates = addonDates.filter(_ref4 => {
        let {
          productDrawId
        } = _ref4;
        return productDrawId === drawId;
      });
    }
    if (!addonDates.every(addonDate => Boolean(dates[addonDate.date]))) {
      svs.numbergames.results.logger.warn('Joker has been closed on other days than Lotto or Vikinglotto.');
      svs.numbergames.results.logger.debug('Want code that tries to handle it and move Joker to correct day?');
      svs.numbergames.results.logger.debug('Give your developers some cookies and we might just make it happen. ;)');
      addonDates = addonDates.filter(addonDate => Boolean(dates[addonDate.date]));
    }
    return addonDates;
  }
}
function parseDates(datePicker, addonDatePicker) {
  const dates = parseDatesByMonth(datePicker);
  let datesMap = addDates(dates);
  if (datesMap && addonDatePicker) {
    let addonDates = parseDatesByMonth(addonDatePicker);
    addonDates = checkAddonDates(datesMap, addonDates, datePicker.product);
    datesMap = addAddonDates(addonDates, datesMap);
  }
  return datesMap;
}
svs.numbergames.results.parsers.datePicker = {
  parseDates,
  createDate
};

 })(window);